export const UI_3_1_tableRow = [
  [
    {
      cellName: "알림번호",
      id: "alarmNo",
      row: 1,
      col: 1,
      style: { width: "10%" },
    },
    {
      cellName: "산업단지명",
      id: "complexName",
      row: 1,
      col: 1,
      style: { width: "10%" },
    },
    {
      cellName: "회사명",
      id: "companyName",
      row: 1,
      col: 1,
      style: { width: "10%" },
    },
    {
      cellName: "사업장명",
      id: "plantName",
      row: 1,
      col: 1,
      style: { width: "10%" },
    },
    {
      cellName: "알람종류",
      id: "alarmClCd", 
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "설비명",
      id: "facName", 
      row: 1,
      col: 1,
      style: { width: "15%" },
    },
    {
      cellName: "정비(조치내용)",
      id: "fpactCnt", 
      row: 1,
      col: 1,
      style: { width: "12%" },
    },
    {
      cellName: "정비(조치)시작일",
      id: "fpactStrtDate", 
      row: 1,
      col: 1,
      style: { width: "10%" },
    },
    {
      cellName: "정비(조치)종료일",
      id: "fpactEndDate", 
      row: 1,
      col: 1,
      style: { width: "10%" },
    },
    {
      cellName: "",
      id: "fpactButton",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
  ]
]